import { createSlice } from '@reduxjs/toolkit';
import { ResignationState } from './resignationType';
import { createResignation, Updateresignation, fetchResignationById, fetchAllResignations, deleteResignation, getAllHODsAndHr, fetchHierarchyResignationRequests, updateResignationStatus, resignationBySupervisorHierarchy } from './resignationAction';

const initialState: ResignationState = {
    resignation: [],
    getAllHodAndHr: [],
    selectedResignation: undefined,
    resignationRequest: [],
    updateResignation: [],
    resignationBySupervisor: [],
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
        fetchHod: false,
        fetchhierarchy: false,
        fetchUpdatedResignation: false,
        fetchResignationBySupervisor: false
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
        fetchHodAndHr: undefined,
        fetchhierarchy: undefined,
        fetchUpdatedResignation: undefined,
        fetchResignationBySupervisor: undefined
    },
}


const resignationSlice = createSlice({
    name: 'resignation',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createResignation.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createResignation.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.resignation.push(action.payload);
            })
            .addCase(createResignation.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update 
            .addCase(Updateresignation.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(Updateresignation.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.resignation.findIndex((d: any) => d.Id === action.payload.Id);
                if (index !== -1) {
                    state.resignation[index] = action.payload;
                }
            })
            .addCase(Updateresignation.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete 
            .addCase(deleteResignation.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteResignation.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.resignation = state.resignation.filter((d: any) => d.Id !== action.payload);
            })
            .addCase(deleteResignation.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch  by ID
            .addCase(fetchResignationById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchResignationById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedResignation = action.payload;
            })
            .addCase(fetchResignationById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All 
            .addCase(fetchAllResignations.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllResignations.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.resignation = action.payload.data;
            })
            .addCase(fetchAllResignations.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            })

            //getAllHOD
            .addCase(getAllHODsAndHr.pending, (state) => {
                state.loadingStates.fetchHod = true;
                state.errors.fetchHodAndHr = undefined;
            })
            .addCase(getAllHODsAndHr.fulfilled, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.getAllHodAndHr = action.payload.data;
            })
            .addCase(getAllHODsAndHr.rejected, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.errors.fetchHodAndHr = action.payload as string;
            })

            //resignation req by hod and supervisor
            .addCase(fetchHierarchyResignationRequests.pending, (state) => {
                state.loadingStates.fetchHod = true;
                state.errors.fetchhierarchy = undefined;
            })
            .addCase(fetchHierarchyResignationRequests.fulfilled, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.resignationRequest = action.payload.data;
            })
            .addCase(fetchHierarchyResignationRequests.rejected, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.errors.fetchhierarchy = action.payload as string;
            })

            .addCase(updateResignationStatus.pending, (state) => {
                state.loadingStates.fetchHod = true;
                state.errors.fetchUpdatedResignation = undefined;
            })
            .addCase(updateResignationStatus.fulfilled, (state, action) => {
                const { resignationId, status } = action.payload;
                state.updateResignation = state.updateResignation.map((r) =>
                    r.ResignationId === resignationId ? { ...r, ResignationStatus: status } : r
                );
            })
            .addCase(updateResignationStatus.rejected, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.errors.fetchUpdatedResignation = action.payload as string;
            })

            .addCase(resignationBySupervisorHierarchy.pending, (state) => {
                state.loadingStates.fetchHod = true;
                state.errors.fetchUpdatedResignation = undefined;
            })
            .addCase(resignationBySupervisorHierarchy.fulfilled, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.resignationBySupervisor = action.payload;
            })
            .addCase(resignationBySupervisorHierarchy.rejected, (state, action) => {
                state.loadingStates.fetchHod = false;
                state.errors.fetchUpdatedResignation = action.payload as string;
            })
    }
})

export default resignationSlice.reducer;